// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Email: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9">
            <path
                fill="currentColor"
                d="M6,6.75 C5.61257815,6.75 5.22515631,6.62292194 4.89468741,6.36539054 L0,2.55937529 L0,7.875 C0,8.49609375 0.503672004,9 1.125,9 L10.875,9 C11.4963284,9 12,8.49632835 12,7.875 L12,2.55937529 L7.10625029,6.36796904 C6.77578139,6.62343764 6.38671875,6.75 6,6.75 Z M0.381797075,1.90546846 L5.35523415,5.77500057 C5.73468733,6.07031322 6.26624966,6.07031322 6.64570284,5.77500057 L11.6191406,1.90546918 C11.8382814,1.71796846 12,1.4296875 12,1.125 C12,0.503671646 11.4960938,0 10.875,0 L1.125,0 C0.503672004,0 0,0.503671646 0,1.125 C0,1.4296875 0.140859246,1.71796846 0.381796718,1.90546846 L0.381797075,1.90546846 Z"
            />
        </svg>
    );
};

export default React.memo(Email);
